import { StyleSheet } from "aphrodite";

export const style = StyleSheet.create({
    headerOne:{
        padding: '0px 20px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '8px',
        boxShadow: '0px 1px 4px 0px rgba(204,204,204,0.8)',
        "@media (max-width: 767.98px)": {
            padding: '8px 12px',
        },
    },
    header:{
        background: 'linear-gradient(to right, #4969D6, #29C6FF)',
        overflow: 'visible',
    },
    title:{
        color: 'white',
        fontSize: '18px',
        lineHeight: '16px',
        display: 'flex',
        flex: '1',
        alignItems: 'center',
        textTransform: "uppercase",
        minWidth: '120px',
        "@media (max-width: 767.98px)": {
            fontSize: '15px',
        },
    },
    divIcon:{
        display: 'flex',
        flex: '1',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '12px',
        flexWrap: 'wrap',
        "@media (max-width: 767.98px)": {
            flex: '1 1 100%',
            justifyContent: 'space-between',
        },
    },
    iconsMenu:{
        cursor: 'pointer'
    }
});
